import { Component, OnInit } from '@angular/core';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';

@Component({
  selector: 'tt-edi-exports',
  templateUrl: './edi-exports.component.html',
  styleUrls: ['./edi-exports.component.css'],
  standalone: false
})
export class EdiExportsComponent implements OnInit {
    public grid?: GridOptions;

    private loadGrid() {
        if (!this.grid) {
            this.grid = new Grid().setRememberId('w_ediimportsComponentGrid').setLoadDataFunction({ method: 3353, parameters: {} }).setKendoConfig({ height: '100%' }).setToolbar({ wrapping: true });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    private async init() {
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}
